<template>
  <div class="notification_modal">
    <div class="notification_modal-overlay" @click="switchNotificationModal"></div>
    <div class="notification_modal-card">
      <div class="card-body">
        <div class="body-block">
          <div class="card-tags">
            <div class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--primary ccs-tag--no_action">
              {{ stringDateToText(notification.created_at) }}
            </div>
          </div>
          <div class="card-info">
            <div class="info-message">
              {{ getNotificationMessage(notification) }}
            </div>
          </div>
        </div>
      </div>
      <div class="card-actions">
        <button class="card-action" v-if="permissionsStatus.isEventViewAllowed || permissionsStatus.isEventViewAllAllowed"
          @click="goToEvent">
          Перейти к мероприятию
        </button>
        <button class="card-action" v-if="notification.project &&
          (permissionsStatus.isProjectViewAllowed || permissionsStatus.isProjectViewAllAllowed)"
          @click="goToProject">
          Перейти к проекту
        </button>
        <button class="card-action" v-if="notification.control_point &&
          (permissionsStatus.isControlPointViewAllowed || permissionsStatus.isControlPointViewAllAllowed)"
          @click="openControlPointByID(notification.control_point.id)">
          Просмотр контрольной точки
        </button>
        <button class="card-action" v-if="notification.control_point_request &&
          (permissionsStatus.isControlPointRequestViewAllowed || permissionsStatus.isControlPointRequestViewAllAllowed)"
          @click="openControlPointRequestByID(notification.control_point_request.id)">
          Просмотр запроса на изменение
        </button>
        <button class="card-action card-action--delete" v-if="permissionsStatus.isEventNotificationDeleteAllowed"
          @click="removeNotification">
          Удалить уведомление
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

import { getNotificationMessage } from '@/helpers/notification.js';
import DateRender from '@/mixins/DateRender';

export default {
  name: 'NotificationModal',
  mixins: [DateRender],
  computed: {
    ...mapState('projects', ['notification']),
    ...mapGetters('session', ['permissionsStatus']),
  },
  methods: {
    ...mapMutations('projects', ['switchNotificationModal']),
    ...mapActions('projects', [
      'openControlPointByID',
      'openControlPointRequestByID',
      'deleteNotification',
    ]),
    getNotificationMessage(notification) {
      return getNotificationMessage(notification);
    },
    goToEvent() {
      const link = this.$router.resolve({ name: 'event', params: { eventID: this.notification.event.id } });
      window.open(link.href, '_blank');
    },
    goToProject() {
      const link = this.$router.resolve({ name: 'project', params: { projectID: this.notification.project.id } });
      window.open(link.href, '_blank');
    },
    removeNotification() {
      this.$toasted.info("Удалить уведомление?", { action: [{
        text: "Да",
        onClick: (e, toastObject) => {
          this.removeNotificationRequest();
          toastObject.goAway(0);
        },
      }, {
        text: "Нет",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        },
      }]});
    },
    async removeNotificationRequest() {
      try {
        await this.deleteNotification({
          eventID: this.notification.event.id,
          notificationID: this.notification.id,
        });
        this.switchNotificationModal();
        this.$toasted.success('Уведомление удалено');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
  mounted() {
    window.onscroll = function () { window.scrollTo(0, 0); };
  },
  beforeDestroy() {
    window.onscroll = undefined;
  },
}
</script>

<style lang="scss" scoped>
.notification_modal {
  z-index: 100;
  position: fixed;
  left: 0;
  height: 100%;
  width: 100%;
  overflow-y: scroll;

  &-overlay {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: #000;
    opacity: 0.8;
  }

  &-card {
    z-index: 101;
    position: relative;
    left: 50%;
    margin-top: 100px;
    margin-bottom: 100px;
    padding: 20px 20px 10px 20px;
    width: 700px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 10px;
    transform: translateX(-50%);

    .card {

      &-actions {
        margin-top: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
      }

      &-action {
        padding: 10px;
        margin-bottom: 10px;
        height: 31px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: $primary;
        color: #fff;
        border: 1px solid $primary;
        border-radius: 5px;
        font-size: 14px;
        transition: color ease-in-out .2s,
                    border ease-in-out .2s,
                    background ease-in-out .2s;

        &:hover {
          color: $primary;
          background: #fff;
          cursor: pointer;
        }

        &:not(:last-child) {
          margin-right: 10px;
        }

        &--delete {
          background: #fff;
          color: $secondary;
          border: 1px solid $secondary;

          &:hover {
            color: #fff;
            background: $secondary;
            cursor: pointer;
          }

        }

      }


      &-tags {
        margin-bottom: 15px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
      }

      &-body {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

        .body-block {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          .card {

            &-info {
              width: 100%;

              .info {

                &-message {
                  width: 100%;
                  font-size: 20px;
                  overflow-wrap: anywhere;
                  line-height: 1.2;
                }

              }

            }

          }

        }

      }

    }

  }

}
</style>